import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';

import type { DepositSuggestions } from '../../../types/Cashier';
import type { CardType } from '../../../types/cardType';

const useSuggestedPaySystems = (type: CardType, transactionId?: string): DepositSuggestions => {
  const request = useRequest();
  const [suggestedPaySystems, setSuggestedPaySystems] = useState<DepositSuggestions>([]);

  useEffect(() => {
    if (type) {
      request<DepositSuggestions>({
        service: 'wc3.paysystem.get.suggestedPaySystems',
        body: { type, transactionId }
      }).subscribe(({ body }) => setSuggestedPaySystems(body));
    }
  }, [type, transactionId, request]);

  return suggestedPaySystems;
};

export default useSuggestedPaySystems;
